import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  EntryHtsControlComponent,
  EsAttachDocumentComponent,
  EsBatchItemsComponent,
  EsBatchReviewSidebarComponent,
  EsBatchSidebarComponent,
  EsBillLadingAttachDocumentComponent,
  EsBillOfLadingEditDesktopComponent,
  EsBillOfLadingFormDesktopComponent,
  EsBillOfLadingViewDesktopComponent,
  EsBondsDesktopComponent,
  EsCardDesktopComponent,
  EsCardNoticeComponent,
  EsChatDesktopComponent,
  EsDetailsBillOfLadingCardComponent,
  EsDetailsBondCardComponent,
  EsDetailsCardComponent,
  EsDetailsComponent,
  EsDetailsEntityDesktopComponent,
  EsDetailsImporterCardComponent,
  EsDetailsInvoiceCardComponent,
  EsDetailsInvoiceCardDesktopComponent,
  EsDetailsInvoiceCardEditableDesktopComponent,
  EsDetailsInvoiceCardFormDesktopComponent,
  EsDetailsInvoiceCardHtsDesktopComponent,
  EsDetailsInvoiceOcrCardDesktopComponent,
  EsDetailsInvoiceOcrCardFormDesktopComponent,
  EsDetailsInvoiceOcrCardHtsDesktopComponent,
  EsDetailsInvoiceOcrCardMainDesktopComponent,
  EsDetailsShipmentCardComponent,
  EsDetailsSubcardComponent,
  EsDetailsTotalComponent,
  EsDocsStripComponent,
  EsDocumentDownloadComponent,
  EsDocumentsBlBoxComponent,
  EsDutiesTypeDesktopComponent,
  EsEditShipmentDesktopComponent,
  EsEntityUnifyDefaultDesktopComponent,
  EsHtsItemMobileComponent,
  EsInvoiceAddOcrComponent,
  EsInvoiceAttachDocumentComponent,
  EsInvoiceFormDesktopComponent,
  EsInvoiceReplaceOcrComponent,
  EsInvoiceStepperComponent,
  EsInvoiceSummaryDetailsComponent,
  EsInvoiceSummaryDetailsLineItemComponent,
  EsInvoiceSummaryDetailsTotalComponent,
  EsItemsSearchComponent,
  EsLineItemAttachDocumentComponent,
  EsHtsLinePanelComponent,
  EsLineItemFormDesktopComponent,
  EsLineItemsBulkDeleteModalComponent,
  EsListAdminComponent,
  EsListComponent,
  EsListDetailComponent,
  EsListDetailDeliveryActionComponent,
  EsOcrQuickFixBlDetailsComponent,
  EsOcrQuickFixHeaderComponent,
  EsOcrQuickFixInvoiceMainDetailsComponent,
  EsOcrQuickFixLineItemDetailsComponent,
  EsOcrQuickFixMainShipmentDetailsComponent,
  EsOcrQuickFixManufacturerDetailsComponent,
  EsOcrQuickFixSellerConsigneeDetailsComponent,
  EsOcrQuickFixShipmentTypeDetailsComponent,
  EsOcrQuickFixShippingTosComponent,
  EsPaymentButtonComponent,
  EsPoaDocumentDownloadComponent,
  EsPoaSidebarComponent,
  EsPoaSidebarComponentOld,
  EsPunDocumentDownloadComponent,
  EsShipmentDetailsDesktopComponent,
  EsShipmentDetailsFormDesktopComponent,
  EsShipmentDutiesPaymentFormDesktopComponent,
  EsShipmentFormDesktopComponent,
  EsShipmentSummaryDesktopComponent,
  EsStatusComponent,
  EsSummaryCbpLogDesktopComponent,
  EsSummarySuccessHeaderDesktopComponent,
  EsTermsOfSaleDesktopComponent,
  EsUploadDocumentsDesktopComponent,
  EsValidationHeaderDesktopComponent,
  PrimaryButtonComponent,
  SummaryComponent,
} from './components';
import { TranslateModule } from '@ngx-translate/core';
import { CustomModalModule } from '@shared/custom-modal/custom-modal.module';
import { DocumentModule } from '@shared/document/document.module';
import { IconsModule } from '@shared/icons/icons.module';
import { NgxMaskModule } from 'ngx-mask';

import { PipesSharedModule } from '@shared/pipes-shared/pipes-shared.module';
import { RouterModule } from '@angular/router';
import { CbpMessagesModule } from '@shared/cbp-messages/cbp-messages.module';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { InfoModule } from '@shared/info/info.module';
import { CardsModule } from '@shared/cards/cards.module';
import { AddressModule } from '@shared/address/address.module';
import { FormWrapperModule } from '@shared/form-wrapper/form-wrapper.module';
import { BillSharedModule } from '@shared/bill-shared/bill-shared.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { EntityMutualModule } from '@shared/entity-mutual/entity-mutual.module';
import { MutualModule } from '@shared/mutual/mutual.module';
import { PaginationModule } from '@shared/pagination/pagination.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { PaymentButtonExternalModule } from '@shared/payment-button-external/payment-button-external.module';
import { EsActionsComponent } from './components/es-actions/es-actions.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { MissingFieldsModule } from '@shared/missing-fields/missing-fields.module';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { MarineInsuranceSharedModule } from '@shared/marine-insurance-shared';
import { PaymentButtonSharedModule } from '@shared/payment-button-shared';
import { BatchImportMutualModule } from '@shared/batch-import-mutual/batch-import-mutual.module';
import { BrokerMessagesModule } from '@shared/broker-messages/broker-messages.module';
import { HtsAssistantModule } from '@shared/hts-assistant/hts-assistant.module';
import { HtsAssistantLauncherService } from '@shared/hts-assistant/services';
import { InternalNotesModule } from '@shared/internal-notes/internal-notes.module';
import { PaymentSharedModule } from '@shared/payment-shared';
import { EntityModule } from '@shared/entity/entity.module';
import { ResultModule } from '@shared/result/result.module';
import { BinaSidebarMutualModule } from '@shared/bina-mutual/bina-sidebar-mutual.module';
import { BinaSharedModule } from '@shared/bina-shared/bina-shared.module';
import { CustomToastModule } from '@shared/custom-toast/custom-toast.module';
import { EsOcrQuickFixSidebarComponent } from './components/es-ocr-quick-fix-sidebar/es-ocr-quick-fix-sidebar.component';
import { LayoutsModule } from '@shared/layouts/layouts.module';
import { IdentifierUpdateModule } from '@shared/identifier-update/identifier-update.module';
import { CompanyModule } from '@app/modules/company/company.module';
import { PoaRequiredModalModule } from '@shared/poa-required-modal/poa-required-modal.module';

@NgModule({
  declarations: [
    EsActionsComponent,
    EsBillLadingAttachDocumentComponent,
    EsAttachDocumentComponent,
    EsInvoiceAttachDocumentComponent,
    EsLineItemAttachDocumentComponent,
    EsLineItemsBulkDeleteModalComponent,
    EsDocumentDownloadComponent,
    EsPoaDocumentDownloadComponent,
    EsPunDocumentDownloadComponent,
    EsCardNoticeComponent,
    EsDetailsComponent,
    EsDetailsShipmentCardComponent,
    EsDetailsBondCardComponent,
    EsDetailsImporterCardComponent,
    EsDetailsBillOfLadingCardComponent,
    EsDetailsTotalComponent,
    EsDetailsCardComponent,
    EsDetailsSubcardComponent,
    EsDetailsInvoiceCardComponent,
    EsInvoiceSummaryDetailsComponent,
    EsInvoiceSummaryDetailsTotalComponent,
    EsInvoiceSummaryDetailsLineItemComponent,
    EsListComponent,
    EsListDetailComponent,
    EsListDetailDeliveryActionComponent,
    EsItemsSearchComponent,
    EsListAdminComponent,
    EsPaymentButtonComponent,
    EsStatusComponent,

    EsBillOfLadingViewDesktopComponent,
    EsCardDesktopComponent,
    EsShipmentSummaryDesktopComponent,
    EsSummarySuccessHeaderDesktopComponent,
    EsSummaryCbpLogDesktopComponent,
    EsUploadDocumentsDesktopComponent,
    EsDetailsInvoiceCardDesktopComponent,
    EsDetailsInvoiceCardHtsDesktopComponent,
    EsDetailsInvoiceCardEditableDesktopComponent,
    EsDetailsEntityDesktopComponent,
    EsBatchItemsComponent,
    EsBatchSidebarComponent,
    EsBatchSidebarComponent,
    EsBatchReviewSidebarComponent,

    EsEntityUnifyDefaultDesktopComponent,
    EsLineItemFormDesktopComponent,
    EsHtsLinePanelComponent,
    EsInvoiceFormDesktopComponent,
    EsShipmentFormDesktopComponent,
    EsEditShipmentDesktopComponent,
    EsBillOfLadingEditDesktopComponent,
    EsShipmentDetailsDesktopComponent,
    EsShipmentDetailsFormDesktopComponent,
    EsShipmentDutiesPaymentFormDesktopComponent,
    EsTermsOfSaleDesktopComponent,
    EsBillOfLadingFormDesktopComponent,
    EsDutiesTypeDesktopComponent,
    EsBondsDesktopComponent,
    EsChatDesktopComponent,
    EsValidationHeaderDesktopComponent,
    SummaryComponent,
    EntryHtsControlComponent,
    PrimaryButtonComponent,

    EsInvoiceAddOcrComponent,
    EsDetailsInvoiceOcrCardDesktopComponent,
    EsDetailsInvoiceOcrCardHtsDesktopComponent,
    EsDetailsInvoiceOcrCardMainDesktopComponent,
    EsDetailsInvoiceOcrCardFormDesktopComponent,
    EsDetailsInvoiceCardFormDesktopComponent,
    EsHtsItemMobileComponent,
    EsInvoiceReplaceOcrComponent,

    EsInvoiceStepperComponent,
    EsOcrQuickFixHeaderComponent,
    EsDocsStripComponent,
    EsPoaSidebarComponent,
    EsPoaSidebarComponentOld,
    EsDocumentsBlBoxComponent,
    EsOcrQuickFixSidebarComponent,
    EsOcrQuickFixMainShipmentDetailsComponent,
    EsOcrQuickFixShipmentTypeDetailsComponent,
    EsOcrQuickFixBlDetailsComponent,
    EsOcrQuickFixSellerConsigneeDetailsComponent,
    EsOcrQuickFixShippingTosComponent,
    EsOcrQuickFixInvoiceMainDetailsComponent,
    EsOcrQuickFixManufacturerDetailsComponent,
    EsOcrQuickFixLineItemDetailsComponent,
  ],
  imports: [
    CommonModule,
    MutualModule,
    TranslateModule,
    CustomModalModule,
    CustomToastModule,
    LayoutsModule,
    DocumentModule,
    IconsModule,
    NgxMaskModule,
    BinaSharedModule,
    PaginationModule,
    PipesSharedModule,
    RouterModule,
    CbpMessagesModule,
    TooltipModule.forRoot(),
    BsDropdownModule.forRoot(),
    InfoModule,
    CardsModule,
    AddressModule,
    FormWrapperModule,
    BillSharedModule,
    FlexLayoutModule,
    EntityMutualModule,
    MutualModule,
    CustomModalModule,
    NgSelectModule,
    PaymentButtonExternalModule,
    NgxPaginationModule,
    NzToolTipModule,
    MissingFieldsModule,
    NzPopoverModule,
    MarineInsuranceSharedModule,

    PaymentButtonSharedModule,
    BatchImportMutualModule,
    BrokerMessagesModule,
    HtsAssistantModule,
    InternalNotesModule,
    PaymentSharedModule,
    EntityModule,
    IdentifierUpdateModule,
    ResultModule,

    BinaSidebarMutualModule,
    CompanyModule,
    PoaRequiredModalModule,
  ],
  exports: [
    EsActionsComponent,
    EsBillLadingAttachDocumentComponent,
    EsAttachDocumentComponent,
    EsInvoiceAttachDocumentComponent,
    EsLineItemAttachDocumentComponent,
    EsLineItemsBulkDeleteModalComponent,
    EsCardNoticeComponent,
    EsDetailsComponent,
    EsInvoiceSummaryDetailsComponent,
    EsInvoiceSummaryDetailsTotalComponent,
    EsInvoiceSummaryDetailsLineItemComponent,
    EsListComponent,
    EsListAdminComponent,
    EsPaymentButtonComponent,
    EsStatusComponent,

    EsBillOfLadingViewDesktopComponent,
    EsCardDesktopComponent,
    EsShipmentSummaryDesktopComponent,
    EsSummarySuccessHeaderDesktopComponent,
    EsSummaryCbpLogDesktopComponent,
    EsUploadDocumentsDesktopComponent,
    EsDetailsInvoiceCardDesktopComponent,
    EsDetailsInvoiceCardHtsDesktopComponent,
    EsDetailsInvoiceCardEditableDesktopComponent,
    EsDetailsEntityDesktopComponent,
    EsBatchSidebarComponent,
    EsBatchItemsComponent,
    EsBatchReviewSidebarComponent,

    EsEntityUnifyDefaultDesktopComponent,
    EsLineItemFormDesktopComponent,
    EsHtsLinePanelComponent,
    EsInvoiceFormDesktopComponent,
    EsShipmentFormDesktopComponent,
    EsEditShipmentDesktopComponent,
    EsBillOfLadingEditDesktopComponent,
    EsShipmentDetailsDesktopComponent,
    EsShipmentDetailsFormDesktopComponent,
    EsShipmentDutiesPaymentFormDesktopComponent,
    EsTermsOfSaleDesktopComponent,
    EsBillOfLadingFormDesktopComponent,
    EsDutiesTypeDesktopComponent,
    EsBondsDesktopComponent,
    EsChatDesktopComponent,
    EsValidationHeaderDesktopComponent,
    SummaryComponent,
    EntryHtsControlComponent,
    PrimaryButtonComponent,

    EsInvoiceAddOcrComponent,
    EsDetailsInvoiceOcrCardDesktopComponent,
    EsDetailsInvoiceOcrCardHtsDesktopComponent,
    EsDetailsInvoiceOcrCardMainDesktopComponent,
    EsDetailsInvoiceOcrCardFormDesktopComponent,
    EsDetailsInvoiceCardFormDesktopComponent,
    EsHtsItemMobileComponent,
    EsInvoiceReplaceOcrComponent,
    EsInvoiceStepperComponent,
    EsOcrQuickFixHeaderComponent,
    EsDocsStripComponent,
    EsPoaSidebarComponent,
    EsPoaSidebarComponentOld,
    EsDocumentsBlBoxComponent,
    EsOcrQuickFixSidebarComponent,
    EsOcrQuickFixMainShipmentDetailsComponent,
    EsOcrQuickFixShipmentTypeDetailsComponent,
    EsOcrQuickFixBlDetailsComponent,
    EsOcrQuickFixSellerConsigneeDetailsComponent,
    EsOcrQuickFixShippingTosComponent,
    EsOcrQuickFixInvoiceMainDetailsComponent,
    EsOcrQuickFixManufacturerDetailsComponent,
    EsOcrQuickFixLineItemDetailsComponent,
  ],
})
export class EsMutualModule {
  /** The standalone assistant drawer shows this module's line panel behind its eye button (demo rework 2026-10-16). */
  constructor(htsAssistantLauncherService: HtsAssistantLauncherService) {
    htsAssistantLauncherService.registerLinePanel(EsHtsLinePanelComponent);
  }
}
